import { SupervisorAccountOutlined, ChromeReaderModeOutlined } from '@material-ui/icons';
import { IconFiles } from '@tabler/icons';
import { BallotOutlined } from '@material-ui/icons';

export const buildProjectMenu = (projectId, projectName, onDismiss, { filesLabel = 'All Files' } = {}) => ({
    id: `project_${projectId}`,
    title: projectName || 'Project',
    caption: 'Current Project',
    type: 'group',
    onDismiss,
    children: [
        {
            id: `project_${projectId}_section`,
            title: projectName || 'Project',
            type: 'collapse',
            icon: BallotOutlined,
            defaultOpen: true,
            // Shows a copy-to-clipboard icon next to the title instead of making the title text
            // itself selectable — the row is also a click-to-expand/collapse button, and
            // dragging to select text there would fight with that click target.
            copyable: true,
            children: [
                {
                    id: `project_${projectId}_suppliers`,
                    title: 'Suppliers',
                    type: 'item',
                    url: `/project/${projectId}/suppliers`,
                    icon: SupervisorAccountOutlined,
                    breadcrumbs: false,
                },
                {
                    id: `project_${projectId}_survey_templates`,
                    title: 'Survey Templates',
                    type: 'item',
                    url: `/project/${projectId}/survey-templates`,
                    icon: ChromeReaderModeOutlined,
                    breadcrumbs: false,
                },
                {
                    id: `project_${projectId}_files`,
                    title: filesLabel,
                    type: 'item',
                    url: `/project/${projectId}/files`,
                    icon: IconFiles,
                    breadcrumbs: false,
                },
            ],
        },
    ],
});
